var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemplates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.333h6.667",
    stroke: "#0C0A0C",
    strokeWidth: 0.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.334 18A1.374 1.374 0 019 19.217 1.18 1.18 0 017.667 18 1.407 1.407 0 019 16.783 1.148 1.148 0 0110.334 18v0z",
    fill: "#0C0A0C",
    stroke: "#0C0A0C",
    strokeWidth: 0.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 3.333H4.667A.667.667 0 004 4v3.333c0 .369.298.667.667.667h14.666A.667.667 0 0020 7.333V4a.667.667 0 00-.667-.667zM19.333 9.333H4.667A.667.667 0 004 10v3.333c0 .368.298.667.667.667h14.666a.667.667 0 00.667-.667V10a.667.667 0 00-.667-.667z",
    fill: "#FA6D41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 15.667H6.667a.667.667 0 00-.667.666v3.334c0 .368.298.666.667.666h14.666a.667.667 0 00.667-.666v-3.334a.667.667 0 00-.667-.666zM12 18.72s3.253-.563 5.333.113M4.667 16.667l-2-1.334M4.334 18H1.667M4.667 19.667a9.427 9.427 0 00-2 1M8.334 11.667A1.373 1.373 0 017 12.883a1.18 1.18 0 01-1.333-1.216A1.407 1.407 0 017 10.45a1.148 1.148 0 011.334 1.217v0zM8.334 5.667A1.373 1.373 0 017 6.883a1.18 1.18 0 01-1.333-1.216A1.407 1.407 0 017 4.45a1.147 1.147 0 011.334 1.217v0z",
    stroke: "#0C0A0C",
    strokeWidth: 0.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgTemplates;